/* @flow */
import React from "react";
import styled, { css } from "styled-components";

import buttonUp from "./button-up.png";
import buttonDown from "./button-down.png";

import TinyArrow from "./ArrowTiny";

const Container = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  height: 140px;

  ${props =>
    props.intent === "CAST_UP" &&
    css`
    top: -140px;
    background-color: rgba(96,163,28,0.1);
    background: linear-gradient(to top, rgba(96,163,28,0.1) 0%, rgba(255,255,255,0) 100%);
  `}

  ${props =>
    props.intent === "CAST_DOWN" &&
    css`
    top: 0;
    background-color: rgba(230,76,60,0.1);
    background: linear-gradient(to bottom, rgba(230,76,60,0.1) 0%, rgba(255,255,255,0) 100%);
  `}
`;

const ArrowView = styled.div`
  position: relative;
  left: 0;
  height: 140px;
  width: 200px;

  ${props =>
    props.intent === "CAST_UP" &&
    css`
    background-image: url(${buttonUp});
  `}

  ${props =>
    props.intent === "CAST_DOWN" &&
    css`
    background-image: url(${buttonDown});
  `}
`;

type Props = {
  height: number,
  intent: "CAST_UP" | "CAST_DOWN" | "",
  x: number,
  y: number
};

export function Arrow({ intent, x, y, height }: Props) {
  if (intent === "") {
    return null;
  }

  const positionX = Math.floor(x);
  const positionY = Math.floor(y);

  const heightMinusArrows = height - positionY;
  const showTiny = heightMinusArrows < 140 || heightMinusArrows > height - 140;

  const ArrowComponent = showTiny ? TinyArrow : ArrowView;

  return (
    <Container
      intent={intent}
      style={{
        WebkitTransform: `translateY(${positionY}px)`,
        transform: `translateY(${positionY}px)`
      }}
    >
      <ArrowComponent
        intent={intent}
        style={{
          WebkitTransform: `translateX(${positionX}px)`,
          transform: `translateX(${positionX}px)`
        }}
      />
    </Container>
  );
}

export default Arrow;



// WEBPACK FOOTER //
// ./src/components/Chart/Arrow.js